import React from "react";
import { FaTimes, FaUser, FaIdCard, FaEnvelope, FaBriefcase, FaMobileAlt, FaFlag, FaBirthdayCake, FaVenusMars, FaSave, FaCheckCircle } from "react-icons/fa";

export default function ViewProfileModal({ user, onClose }) {
  // Define fields with icons and formatting logic
  const userFields = [
    { label: "First Name", value: user.firstName, icon: FaIdCard, color: 'text-blue-500' },
    { label: "Last Name", value: user.lastName, icon: FaIdCard, color: 'text-blue-500' },
    { label: "Email", value: user.email, icon: FaEnvelope, color: 'text-orange-500' },
    { label: "Role", value: user.role, icon: FaBriefcase, color: 'text-green-500' },
    { label: "Status", value: user.isActive ? "Active" : "Inactive", icon: FaCheckCircle, color: user.isActive ? 'text-green-500' : 'text-red-500' },
    { label: "Phone", value: user.mobile || user.tel || "N/A", icon: FaMobileAlt, color: 'text-purple-500' },
    { label: "Nationality", value: user.nationality || "N/A", icon: FaFlag, color: 'text-red-500' },
    { label: "DOB", value: user.dateOfBirth ? new Date(user.dateOfBirth).toLocaleDateString() : "N/A", icon: FaBirthdayCake, color: 'text-pink-500' },
    { label: "Gender", value: user.gender || "N/A", icon: FaVenusMars, color: 'text-teal-500' },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[95vh] flex flex-col overflow-hidden transform transition-all duration-300 ease-out"
      >
        
        {/* Header with Orange Gradient */}
        <div className="flex-shrink-0 bg-gradient-to-r from-orange-500 to-orange-600 border-b border-orange-50">
          <div className="flex items-center justify-between px-6 py-5">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-white/20 backdrop-blur-sm rounded-xl shadow-sm">
                <FaUser className="w-7 h-7 text-white" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white">
                  Profile: {user.firstName} {user.lastName}
                </h2>
                <p className="text-orange-100 mt-1">Detailed Staff Information</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-xl transition-all duration-200 text-orange-200 hover:bg-white/20 hover:text-white hover:shadow-sm"
            >
              <FaTimes className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Body (Scrollable Content) */}
        <div className="flex-grow px-6 py-5 overflow-y-auto space-y-6 bg-gray-50">
          <div className="bg-white rounded-xl p-5 border border-gray-200 shadow-sm">
            <h3 className="text-xl font-semibold text-gray-800 mb-5 border-b pb-3 flex items-center gap-2">
              <FaIdCard className="text-orange-500" /> Key Details
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              {userFields.map(({ label, value, icon: Icon, color }) => (
                <div key={label}>
                  <label className="block text-gray-700 text-sm font-medium mb-1 flex items-center gap-2">
                    <Icon className={`w-4 h-4 ${color}`} />
                    {label}
                  </label>
                  <input
                    type="text"
                    value={value}
                    readOnly
                    className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm bg-gray-100 text-gray-700"
                  />
                </div>
              ))}
            </div>
          </div>
          
          {/* Add more sections here if profile expands (e.g., Contact, Employment) */}
          
        </div>

        {/* Footer (Fixed Actions) */}
        <div className="flex-shrink-0 bg-gray-100 px-6 py-4 border-t border-gray-200">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2.5 rounded-xl font-semibold transition-all duration-200 text-gray-700 hover:bg-gray-200 border border-gray-300 shadow-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}